export default __webpack_public_path__ + "static/media/with out background.81f61055.png";